import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './auth-provider';
import { Skeleton } from '@/components/ui/states';

/**
 * Guardia de rutas.
 *
 * Ojo con lo que ESTO es y lo que NO es: impide que se pinte una pantalla,
 * nada más. La autorización de verdad la hace el servidor en cada petición
 * (plan.md §8.5). Si alguien salta este guardia, la API le seguirá diciendo
 * que no.
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'checking') {
    return (
      <div className="flex h-full">
        <Skeleton className="h-full w-60 rounded-none" />
        <div className="flex-1 space-y-4 p-6">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-64 w-full" />
        </div>
      </div>
    );
  }

  if (status === 'anonymous') {
    // Se recuerda a dónde iba para volver ahí tras entrar: un enlace a una
    // obra concreta debe llevar a esa obra, no al panel.
    return <Navigate to="/acceso" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}
